import(/* webpackMode: "eager", webpackExports: ["V2ResumesScreen"] */ "/app/apps/platform-web/components/v2/screens/V2ResumesScreen.tsx");
